import React from "react";
import { UserOutlined } from "@ant-design/icons";

export default function AdminClientesPage() {
  return (
    <div style={{ padding: "40px 36px" }}>
      <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 4 }}>Clientes</h2>
      <p style={{ color: "#6b7280", marginBottom: 32, fontSize: 14 }}>
        Gestiona los clientes del sistema.
      </p>
    </div>
  );
}
